import React, { useState, useRef, useEffect } from "react";
import { IoIosArrowDown } from "react-icons/io";
const CustomDropdown = ({ language, setLanguage, languageCodes, theme }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Update state instantly when an option is selected
  const handleSelect = (code) => {
    setLanguage(code); // Instantly updates the selected language
    setIsOpen(false);  // Closes the dropdown after selection
    window.location.reload();       
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      {/* Button to open dropdown */}
      <button
        className={`btn rounded-pill ${theme === "light" ? "btn-outline-dark" : "btn-outline-light"} translate-btn`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {languageCodes.find((lang) => lang.code === language)?.name || "Select Language"}
        <span className="arrow-icon"><IoIosArrowDown /></span> 
      </button>

      {/* Dropdown options */}
      {isOpen && (
        <ul className="dropdown-list">
          {languageCodes.map((lang) => (
            <li
              key={lang.code}
              className={language === lang.code ? "selected" : ""}
              onClick={() => handleSelect(lang.code)}
            >
              {lang.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
